// @ts-nocheck
import React from 'react'
import { t } from 'ttag'

import { Box } from 'components/layout/Box/Box'
import { Arrow } from 'components/shared/Arrow/Arrow'
import { TetherPortal } from 'components/shared/TetherPortal/TetherPortal'

import styles from './Tooltip.module.scss'

export const Tooltip = ({
  arrowRef,
  arrowStyle,
  floating,
  floatingStyle,
  message,
  hasArrow,
  isDisabled,
  isToggled,
}) => {
  return (
    <TetherPortal isOpen={isToggled}>
      <Box
        align="center"
        className={styles.tooltip}
        justify="center"
        ref={floating}
        role="status"
        style={floatingStyle}
      >
        {hasArrow ? (
          <Arrow ref={arrowRef} size="small" style={arrowStyle} theme="dark" />
        ) : null}
        <Box
          align="center"
          className={styles.content}
          direction="column"
          justify="center"
          role="tooltip"
        >
          {isDisabled ? (
            <h3 className={styles.title}>{t`Action disabled`}</h3>
          ) : null}
          <p className={styles.text}>{message}</p>
        </Box>
      </Box>
    </TetherPortal>
  )
}
